<template>
    <span v-if="startsAt && endsAt">{{ startsAt }} ~ {{ endsAt }}</span>
    <span v-else>-</span>
</template>

<script>
export default {
    props: ["value"],
    computed: {
        startsAt() {
            return this.value.applicationStartsAt?.toDate();
        },
        endsAt() {
            return this.value.applicationEndsAt?.toDate();
        },
    },
};
</script>

<style></style>
